import './MgtDeviceCard.scss';
import { Device } from 'types/Device';
import React, { MouseEventHandler } from 'react';

interface MgtDeviceCardProps {
  device: Device,
  onClick?: MouseEventHandler | undefined
}

const MgtDeviceCard: React.FC<MgtDeviceCardProps> = ({ device, onClick }) => {
  
  return (
    <div className="mgt-device-card">
      <div className="mgt-device-card__header" onClick={onClick}>
        <div className="mgt-device-card__header-title">
          <div className="mgt-device-card__header-serial">
            {device.serialNumber}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MgtDeviceCard;